import { render, staticRenderFns } from "./StuchineseTable.vue?vue&type=template&id=a5c46192&scoped=true&"
import script from "./StuchineseTable.vue?vue&type=script&lang=js&"
export * from "./StuchineseTable.vue?vue&type=script&lang=js&"
import style0 from "./StuchineseTable.vue?vue&type=style&index=0&id=a5c46192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c46192",
  null
  
)

export default component.exports